import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgBroadcastSolid = function SvgBroadcastSolid(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor",
        viewBox: "0 0 23 23"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        d: "M11.5 9.462c-1.265 0-2.3 1.065-2.3 2.366s1.035 2.366 2.3 2.366 2.3-1.065 2.3-2.366-1.035-2.366-2.3-2.366m6.9 2.366c0-3.903-3.105-7.097-6.9-7.097s-6.9 3.194-6.9 7.097c0 2.176.965 4.105 2.492 5.439.491.428 1.228.24 1.551-.325.31-.541.117-1.223-.327-1.661-.875-.864-1.416-2.065-1.416-3.335 0-2.602 2.07-4.73 4.6-4.73 2.53-.001 4.6 2.128 4.6 4.73 0 1.324-.512 2.515-1.344 3.33-.462.451-.688 1.16-.368 1.72.31.543 1.01.737 1.49.336 1.544-1.29 2.522-3.314 2.522-5.504M11.5 0C5.175 0 0 5.323 0 11.828c0 3.946 1.87 7.412 4.767 9.529.523.382 1.245.185 1.566-.377.315-.55.127-1.246-.373-1.637a9.56 9.56 0 0 1-3.66-7.515c0-5.204 4.14-9.462 9.2-9.462s9.2 4.258 9.2 9.462c0 3.127-1.43 5.795-3.658 7.518-.502.388-.69 1.084-.375 1.634.321.562 1.043.759 1.566.377C21.13 19.24 23 15.774 23 11.828 23 5.323 17.825 0 11.5 0"
    })));
};

export { SvgBroadcastSolid as ReactComponent };
//# sourceMappingURL=BroadcastSolid.svg.es.js.map
